import React from 'react'
import '../styles/login.css'
import LoginForm from '../components/LoginForm'




const Login = () => {
    return (
      <>
        <div className='cont-info'><LoginForm></LoginForm></div>
      </>
    )
  }
  
  export default Login